import { ApiError, DtsMailClient, type ApiRequest, type StreamEventHandler, type Transport } from '@dts/core';

/** Renderer transport: every call goes through the main process, which owns the tokens. */
class IpcTransport implements Transport {
  async request<T>(req: ApiRequest): Promise<T> {
    const r = await window.dts.api.request<T>(req);
    if (!r.ok) throw new ApiError(r.status, r.error);
    return r.data;
  }

  async stream(req: ApiRequest, onEvent: StreamEventHandler, signal?: AbortSignal): Promise<void> {
    const handle = window.dts.api.stream(req, onEvent);
    const abort = () => handle.cancel();
    signal?.addEventListener('abort', abort, { once: true });
    try {
      const r = await handle.done;
      if (!r.ok && !signal?.aborted) throw new ApiError(r.status, r.error);
    } finally {
      signal?.removeEventListener('abort', abort);
    }
  }
}

export const api = new DtsMailClient(new IpcTransport());

export function errorMessage(e: unknown): string {
  if (e instanceof Error) return e.message;
  return String(e);
}
